import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "react-sidebar";
import adminIcon from "../../../../images/new-images/admin-icon.png";
import userIcon from "../../../../images/new-images/user-icon .png";
import logoutIcon from "../../../../images/new-images/resp-logout-black.png";
import "./SideBar.css";

const ResponsiveSideBar = (props) => {
  const logout = () => localStorage.clear();

  const userName =
    localStorage.getItem("user_name") === "null"
      ? "-"
      : localStorage.getItem("user_name");

  const addActiveClassName = (sideBarItem) => {
    if (props.selectedSideNav === sideBarItem) {
      return "active";
    }
  };

  return (
    <div className="Responsive-SideBar">
      <Sidebar
        sidebarClassName="sidebar-layout"
        rootClassName="root"
        overlayClassName="over"
        contentClassName="content"
        open={Boolean(props.sidebarOpen)}
        onSetOpen={props.onSetSidebarOpen}
        sidebar={
          <div className="sidebar-items">
            <div className="user-details">
              <Link to="/new/app/editProfile">
                {localStorage.usertype.includes("admin") ? (
                  <img className="adminIcon" src={adminIcon} />
                ) : (
                  <img className="userIcon" src={userIcon} />
                )}
                <span className="Hello">Hello,</span>
                <span className="userName">{userName}!</span>
              </Link>
            </div>
            <hr />
            <div className="sidebar-navs">
              <ul>
                {props.items.map((sideBarItem, index) => {
                  return (
                    <React.Fragment key={index}>
                      <li className={addActiveClassName(sideBarItem.id)}>
                        {sideBarItem.id === "analysis" ? (
                          <img
                            src={
                              props.selectedSideNav === sideBarItem.id
                                ? sideBarItem.navLightImage
                                : sideBarItem.navImage
                            }
                            alt="nav-image"
                            style={{ opacity: 0.4 }}
                          />
                        ) : (
                          <img
                            src={
                              props.selectedSideNav === sideBarItem.id
                                ? sideBarItem.navLightImage
                                : sideBarItem.navImage
                            }
                            alt="nav-image"
                          />
                        )}
                        {sideBarItem.id === "analysis" ? (
                          <Link
                            to={sideBarItem.link || "#"}
                            style={{
                              backgroundColor: "#fff",
                              cursor: "not-allowed",
                              opacity: "0.4",
                            }}
                          >
                            {sideBarItem.linkName}
                          </Link>
                        ) : (
                          <Link to={sideBarItem.link || "#"}>
                            {sideBarItem.linkName}
                          </Link>
                        )}
                      </li>
                    </React.Fragment>
                  );
                })}
                <hr />
                <li>
                  <i className="fas fa-key icon-space" />
                  <Link to="/change-password">
                    <span>Change Password</span>
                  </Link>
                </li>
                <li>
                <img className="logout-Icon icon-space" src={logoutIcon} alt="Logout" />
                  <Link to="/login">
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        }
      >
        <i
          className="fa fa-bars fa-2x"
          aria-hidden="true"
          onClick={props.onSetSidebarOpen}
          style={
            window.location.pathname === '/new/app/assessment-report' &&
              window.innerWidth < 500 &&
              window.matchMedia('(orientation: portrait)').matches
              ? { paddingTop: '35px' }
              : {}
          }
        />
      </Sidebar>
    </div>
  );
};

export default ResponsiveSideBar;



// WEBPACK FOOTER //
// ./src/new/Components/Sidebar/Responsive/SideBar.jsx